// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"375401af","455":"35e4d201"}[chunkId] + ".chunk.js";
};